// extracted by mini-css-extract-plugin
export var titleLarge = "hero-module--titleLarge--3F0h8";
export var titleSmall = "hero-module--titleSmall--2HnH6";
export var instagram = "hero-module--instagram--3-dCs";
export var instagramLink = "hero-module--instagramLink--2xTOT";
export var scrim = "hero-module--scrim--3u4QR";